import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ResetPasswordFeature } from "@/features/auth/ResetPasswordFeature";

const searchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute("/(auth)/reset-password")({
  validateSearch: searchSchema,
  component: ResetPasswordPage,
  staticData: { authorize: false },
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return <ResetPasswordFeature token={token} />;
}
